import React, { useEffect, useState, useCallback } from 'react';
// import './signup.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useAuthContext } from '../../hooks/UseAuthContext';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const INITIAL_DATA = {
  email: '',
  password: '',
};

function Signin() {
  const [data, setData] = useState(INITIAL_DATA);
  const [disabled, setDisabled] = useState(true);
  const [btnState, setBtnState] = useState('Sign In');
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  // If ProtectedRoute redirected here, location.state.from holds the intended URL
  const from = location.state?.from?.pathname || '/';

  // Validate form completeness
  useEffect(() => {
    setDisabled(!(data.email && data.password));
  }, [data]);

  const handleChange = useCallback((field) => (e) => {
    setData(prev => ({ ...prev, [field]: e.target.value }));
  }, []);

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    setBtnState('Signing in…');

    axios.post(`${process.env.REACT_APP_API_URL}/login`, data, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => {
        setData(INITIAL_DATA);
        toast.success('Welcome back!');
        localStorage.setItem('user', JSON.stringify(response.data));
        dispatch({ type: 'LOGIN', payload: response.data });
        setBtnState('Sign In');
        navigate(from, { replace: true });
      })
      .catch(error => {
        setBtnState('Sign In');
        toast.error(error?.response?.data?.msg || 'Invalid credentials.');
      });
  }, [data, dispatch, navigate]);

  return (
    <div className="signup">
      <div className="signup-form">
        <form onSubmit={handleSubmit}>

          {/* Header */}
          <div className="form-head">
            <h3>Welcome back</h3>
            <p>Sign in to your Alchemy Mix account</p>
          </div>

          {/* Email */}
          <div className="form-input">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={data.email}
              onChange={handleChange('email')}
              placeholder="your@email.com"
              required
              autoComplete="email"
            />
          </div>

          {/* Password */}
          <div className="form-input">
            <label htmlFor="password">Password</label>
            <div className="password-input">
              <input
                id="password"
                type={showPassword ? 'text' : 'password'}
                value={data.password}
                onChange={handleChange('password')}
                placeholder="Enter your password"
                required
                autoComplete="current-password"
              />
              <div
                onClick={() => setShowPassword(prev => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setShowPassword(prev => !prev);
                  }
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={disabled}
            className={disabled ? 'disabled' : 'enable'}
          >
            {btnState}
          </button>

          {/* Forgot Password */}
          <Link to="/forgot-password" style={{ textDecoration: 'none', width: '100%' }}>
            <button type="button" className="forgot-pass">
              Forgot Password?
            </button>
          </Link>

        </form>
      </div>
    </div>
  );
}

export default Signin;